
(() => {
  // Selecteer alle desktop- en mobiele navigatiemenu's
  const menus = {
    chocolate: document.querySelectorAll('ul[nav="chocolate"]'),
    icecream: document.querySelectorAll('ul[nav="icecream"]')
  };

  // Selecteer de modusknoppen voor desktop en mobiel
  const modeItems = document.querySelectorAll(
    '.wide-screen-menu-sitemode li[data-mode] > a, .small-screen-menu-sitemode li[data-mode] > a'
  );

  // Normaliseer URL's zodat ze goed met elkaar vergeleken kunnen worden
  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin)
        .pathname.replace(/\/+$/, "") || "/";
    } catch (error) {
      return "";
    }
  }

  // Haal de menu-paden op die vanuit Shopify Liquid zijn aangemaakt
  const icecreamPaths = (window.icecreamPaths || []).map(normalizePath);
  const chocolatePaths = (window.chocolatePaths || []).map(normalizePath);

  // Bepaal de actieve storefront-modus
  function getMode() {
    const path = normalizePath(window.location.pathname);

    const isIcecream = icecreamPaths.includes(path);
    const isChocolate = chocolatePaths.includes(path);

    // Pagina staat uitsluitend in het ijsmenu
    if (isIcecream && !isChocolate) {
      sessionStorage.setItem("storefrontMode", "icecream");
      return "icecream";
    }

    // Pagina staat uitsluitend in het chocolademenu
    if (isChocolate && !isIcecream) {
      sessionStorage.setItem("storefrontMode", "chocolate");
      return "chocolate";
    }

    // Gedeelde pagina of pagina die in geen van beide menu's staat
    return sessionStorage.getItem("storefrontMode") || "chocolate";
  }

  // Werk alle navigatiemenu's en modusknoppen bij
  function updateMenu() {
    const mode = getMode();

    // Toon of verberg alle chocolademenu's
    menus.chocolate.forEach(menu => {
      menu.style.display = mode === "chocolate" ? "" : "none";
    });

    // Toon of verberg alle ijsmenu's
    menus.icecream.forEach(menu => {
      menu.style.display = mode === "icecream" ? "" : "none";
    });

    // Zet de actieve class op de juiste <a>-elementen
    modeItems.forEach(link => {
      const item = link.closest("li");

      if (!item) return;

      link.classList.toggle(
        "mode-active",
        item.dataset.mode === mode
      );
    });

    // Bewaar de actieve modus op het HTML-element
    document.documentElement.dataset.storefrontMode = mode;
  }

  // Bewaar de gekozen modus wanneer iemand op een modusknop klikt
  modeItems.forEach(link => {
    link.addEventListener("click", () => {
      const item = link.closest("li");

      if (item && item.dataset.mode) {
        sessionStorage.setItem(
          "storefrontMode",
          item.dataset.mode
        );
      }
    });
  });

  // Voer de menu-update direct uit
  updateMenu();

  // Werk de menu's opnieuw bij bij browsernavigatie
  window.addEventListener("pageshow", updateMenu);
  window.addEventListener("popstate", updateMenu);

})();
